
export var searchHelper = (function() {

	return({
		isFuzzyMatch: isFuzzyMatch,
		isFuzzyMatchMulti: isFuzzyMatchMulti,
		normalizePipeText: normalizePipeText,
		normalizeText: normalizeText
	});

	// ---
	// PUBLIC METHODS.
	// ---

	function isFuzzyMatch( target, keywords ) {

		if ( ! keywords ) {

			return( true );

		}

		var targetChars = [ ...target ];
		var searchChars = [ ...keywords ];
		var searchChar = null;
		var targetChar = null;

		while ( searchChar = searchChars.shift() ) {

			while ( targetChar = targetChars.shift() ) {

				if ( targetChar === searchChar ) {

					if ( ! searchChars.length ) {

						return( true );

					}

					break;

				}

			}

			if ( ! targetChars.length ) {

				break;

			}

		}

		return( false );

	}


	function isFuzzyMatchMulti( targets, keywords ) {

		if ( ! keywords ) {

			return( true );

		}

		for ( var target of targets ) {

			if ( isFuzzyMatch( target, keywords ) ) {

				return( true );

			}

		}

		return( false );

	}


	function normalizePipeText( input ) {

		var parts = input.split( "|" )
			.map( part => normalizeText( part ) )
			.filter( part => part.length )
		;

		return( parts );

	}


	function normalizeText( input ) {

		return( input.toLowerCase().replace( /[^\w|]+/g, "" ).trim() );

	}

})();

export default searchHelper;
